var _path, _path2, _path3, _path4, _path5, _circle, _path6, _g, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m488 256v-168a32 32 0 0 0 -32-32h-71.13651a32 32 0 0 0 -16.46387 4.56023l-24.79924 14.87954a32 32 0 0 1 -16.46387 4.56023h-271.13651a32 32 0 0 0 -32 32v152z",
    fill: "#cf8300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m144 456h-88a32 32 0 0 1 -32-32v-232h120z",
    fill: "#de9400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m488 256h-408a56 56 0 0 1 -56-56v-32a32 32 0 0 1 32-32h276.775a32 32 0 0 1 19.99024 7.0122l22.4695 17.9756a32 32 0 0 0 19.99026 7.0122h60.775a32 32 0 0 1 32 32z",
    fill: "#f6bb00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m488 256h-360a56 56 0 0 0 -56 56v144h384a32 32 0 0 0 32-32z",
    fill: "#eda600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m384 376v-8l16-72h32l16 72v8a32 32 0 0 1 -32 32 32 32 0 0 1 -32-32z",
    fill: "#517ef7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 376,
    fill: "#253899",
    r: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m120 248h368v16h-368z",
    fill: "#cf8300"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#de9400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136 232h16v48h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 232h16v48h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 232h16v48h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 232h16v48h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 232h16v48h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 232h16v48h-16z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m384 248h64v48h-64z",
    fill: "#486be0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.38144704c79ffe77180fa9fc7fe20dd7.svg";
export { ForwardRef as ReactComponent };